<template>
  <div class="Index">
    <Home></Home>
  </div>
</template>

<script>
import Home from '@/components/HomeAndRedirectPage.vue';

export default {
  name: 'homeView',
  components: {
    Home
  }
}
</script>
